import { render, staticRenderFns } from "./orderTabFour.vue?vue&type=template&id=a7ffbd92&scoped=true"
import script from "./orderTabFour.vue?vue&type=script&lang=js"
export * from "./orderTabFour.vue?vue&type=script&lang=js"
import style0 from "./orderTabFour.vue?vue&type=style&index=0&id=a7ffbd92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ffbd92",
  null
  
)

export default component.exports